import { useEffect } from "react";
import { motion } from "framer-motion";
import { siteConfig } from "@/lib/site-config";

/**
 * Customer reviews section — renders the Reputation Hub embed at its native height.
 *
 * The section is hidden entirely until `reviewIframeSrc` is configured in
 * siteConfig.widgets, so the page never shows a reviews heading with nothing
 * underneath it.
 */
const ReviewWidget = () => {
  const { reviewIframeSrc, reviewScriptSrc } = siteConfig.widgets;

  useEffect(() => {
    if (!reviewIframeSrc) return;
    const scriptId = "reputation-hub-review-script";
    if (!document.getElementById(scriptId)) {
      const s = document.createElement("script");
      s.id = scriptId;
      s.src = reviewScriptSrc;
      s.type = "text/javascript";
      s.async = true;
      document.body.appendChild(s);
    }
  }, [reviewIframeSrc, reviewScriptSrc]);

  if (!reviewIframeSrc) return null;

  return (
    <section className="section-padding section-gradient-soft">
      <div className="container-max">
        <div className="text-center mb-10 md:mb-12">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Customer Reviews
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            What Our <span className="text-gradient-primary">Clients</span> Say
          </motion.h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
            Reviews from homes and businesses across Orange Park, Jacksonville, and St. Johns County.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="review-widget-wrap max-w-5xl mx-auto"
        >
          <iframe
            className="lc_reviews_widget"
            src={reviewIframeSrc}
            frameBorder={0}
            scrolling="no"
            style={{ minWidth: "100%", width: "100%", border: "none", display: "block" }}
            title="Customer reviews"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ReviewWidget;
